export function EventManagementIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 2V4M14 2V4M3 8H17M5 4H15C16.1046 4 17 4.89543 17 6V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V6C3 4.89543 3.89543 4 5 4Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="10" cy="12" r="2" fill="currentColor" />
    </svg>
  )
}

export function EventDashboardIcon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="8" width="32" height="32" rx="4" stroke="#8C57FF" strokeWidth="2" />
      <rect x="12" y="12" width="8" height="8" rx="2" fill="#8C57FF" />
      <rect x="28" y="12" width="8" height="8" rx="2" fill="#56CA00" />
      <rect x="12" y="28" width="8" height="8" rx="2" fill="#FF4C51" />
      <rect x="28" y="28" width="8" height="8" rx="2" fill="#FFB400" />
    </svg>
  )
}

export function EventsDiscussionsIcon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 8H36C38.2091 8 40 9.79086 40 12V28C40 30.2091 38.2091 32 36 32H20L12 40V12C12 9.79086 13.7909 8 16 8Z"
        stroke="#16B1FF"
        strokeWidth="2"
        fill="#E3F2FD"
      />
      <circle cx="20" cy="20" r="2" fill="#16B1FF" />
      <circle cx="24" cy="20" r="2" fill="#16B1FF" />
      <circle cx="28" cy="20" r="2" fill="#16B1FF" />
      <path d="M8 16H12V24H8C6.89543 24 6 23.1046 6 22V18C6 16.8954 6.89543 16 8 16Z" fill="#8C57FF" />
    </svg>
  )
}

export function TicketsOrdersIcon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="12" width="32" height="24" rx="4" stroke="#56CA00" strokeWidth="2" fill="#E8F5E8" />
      <circle cx="8" cy="24" r="4" fill="white" stroke="#56CA00" strokeWidth="2" />
      <circle cx="40" cy="24" r="4" fill="white" stroke="#56CA00" strokeWidth="2" />
      <path d="M16 20H32M16 24H32M16 28H24" stroke="#56CA00" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M28 28L32 32L40 24" stroke="#56CA00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function OrdersIcon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="8" width="32" height="32" rx="4" stroke="#FFB400" strokeWidth="2" fill="#FFF8E1" />
      <path d="M16 16H32M16 24H32M16 32H24" stroke="#FFB400" strokeWidth="2" strokeLinecap="round" />
      <circle cx="32" cy="32" r="8" fill="#FFB400" />
      <path d="M28 32L30 34L36 28" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function AttendeesIcon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="16" r="6" stroke="#8C57FF" strokeWidth="2" fill="#F3E5F5" />
      <circle cx="30" cy="16" r="6" stroke="#16B1FF" strokeWidth="2" fill="#E3F2FD" />
      <path d="M8 36C8 30 12 26 18 26C24 26 28 30 28 36" stroke="#8C57FF" strokeWidth="2" fill="#F3E5F5" />
      <path d="M20 36C20 30 24 26 30 26C36 26 40 30 40 36" stroke="#16B1FF" strokeWidth="2" fill="#E3F2FD" />
    </svg>
  )
}

export function CheckInIcon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="8" width="32" height="32" rx="4" stroke="#56CA00" strokeWidth="2" fill="#E8F5E8" />
      <path d="M16 24L22 30L32 18" stroke="#56CA00" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="40" cy="8" r="4" fill="#FF4C51" />
      <path d="M38 6L42 10M42 6L38 10" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export function AccessCodesIcon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="16" width="32" height="16" rx="4" stroke="#FF4C51" strokeWidth="2" fill="#FFEBEE" />
      <circle cx="16" cy="24" r="2" fill="#FF4C51" />
      <circle cx="24" cy="24" r="2" fill="#FF4C51" />
      <circle cx="32" cy="24" r="2" fill="#FF4C51" />
      <path d="M20 8V16M28 8V16" stroke="#FF4C51" strokeWidth="2" strokeLinecap="round" />
      <path d="M20 32V40M28 32V40" stroke="#FF4C51" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export function EventReportsIcon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="8" width="32" height="32" rx="4" stroke="#16B1FF" strokeWidth="2" fill="#E3F2FD" />
      <path
        d="M16 32L20 28L24 30L28 24L32 26"
        stroke="#16B1FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="16" cy="32" r="2" fill="#16B1FF" />
      <circle cx="20" cy="28" r="2" fill="#56CA00" />
      <circle cx="24" cy="30" r="2" fill="#FFB400" />
      <circle cx="28" cy="24" r="2" fill="#FF4C51" />
      <circle cx="32" cy="26" r="2" fill="#8C57FF" />
      <path d="M12 16H36M12 20H24" stroke="#16B1FF" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}
